export const selectors = {
  fieldSelector: '.row',
  nextButton: '#btnNext',
  panelSelector: '.panel',
  prevButton: '#btnBack',
}